var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var ArrowLeft = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M6.70710678,13 L10.8547821,17.1482094 C11.0500443,17.3434715 11.0500443,17.660054 10.8547821,17.8553162 C10.65952,18.0505783 10.3429375,18.0505783 10.1476753,17.8553162 L4.79289322,12.5 L10.1476753,7.15325928 C10.3429375,6.95799713 10.65952,6.95799713 10.8547821,7.15325928 C11.0500443,7.34852142 11.0500443,7.66510391 10.8547821,7.86036606 L6.70710678,12 L19,12 L19,13 L6.70710678,13 Z" })));
};
ArrowLeft.displayName = 'ArrowLeft';
export default ArrowLeft;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ArrowLeft.js.map